import axios from "axios";

const axiosInstance = axios.create();

axiosInstance.defaults.baseURL = process.env.REACT_APP_API_URL;
axiosInstance.defaults.withCredentials = true;

axiosInstance.interceptors.response.use(
  (response) => {
    // Handle successful responses
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 403) {
      window.location.href = '/login'; // Redirects to login page
    }
    return Promise.reject(error);
  }
);


export default axiosInstance;